common.View.create('website::layouts.Main', {

    onDOMLoad() {
        this.initNavbar();
        this.initScrollToAnchor();
        this.initSlider();
    },

    initNavbar() {
        // Give parent .active when has a .active subitem
        $('.navbar-nav .dropdown-menu > .dropdown-item.active').each(function () {
            $(this).parents('.nav-item').find('.nav-link').addClass('active');
        });
    },

    initScrollToAnchor()
    {
        $(document).on('click', "a[href^='#']", function(e) {
            // prevent default anchor click behavior
            e.preventDefault();

            // animate
            $('html, body').animate({
                scrollTop: $(this.hash).offset().top - ($('header .stickyNavItems').height() || 0)
            }, 100);
        });
    },

    initSlider() {
        let owlCarousel = $('header .owl-carousel');

        if (!owlCarousel.hasClass('disable-slider')) {
            let options = {
                items: 1,
                loop: owlCarousel.find('> *').length > 1,
                autoplay: true,
                autoplayTimeout: 7500,
                autoplayHoverPause: true,
                autoplaySpeed: 1000,
                stageClass: 'owl-stage h-full',
                stageOuterClass: 'owl-stage-outer h-full',
                itemClass: 'owl-item h-full',
            };

            if (owlCarousel.hasClass('fade')) {
                options = {
                    ...options,
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                };
            }

            owlCarousel.owlCarousel(options);
        }
    },
});
